import { Dropdown } from 'react-bootstrap';
import { getListOfSchoolYears } from '../reportUtilities';
import styles from './SchoolYearSelector.module.scss';

interface SchoolYearSelectorProps {
  selectedSchoolYear: string;
  onSelectSchoolYear: (schoolYear: string) => void;
  disabled?: boolean;
}

const SchoolYearSelector = ({
  selectedSchoolYear,
  onSelectSchoolYear,
  disabled = false,
}: SchoolYearSelectorProps): JSX.Element => {
  const schoolYears = getListOfSchoolYears();
  const selectedYearObj = schoolYears.find((y) => y.id === selectedSchoolYear);

  return (
    <div className={styles.schoolYearSelector}>
      <label className={styles.label}>School Year:</label>
      <Dropdown onSelect={(eventKey) => onSelectSchoolYear(eventKey || '')}>
        <Dropdown.Toggle
          variant='outline-primary'
          id='school-year-dropdown'
          disabled={disabled}
          className={styles.dropdownToggle}
        >
          {selectedYearObj?.name || 'Select School Year'}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {schoolYears.map((year) => (
            <Dropdown.Item key={year.id} eventKey={year.id} active={year.id === selectedSchoolYear}>
              {year.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default SchoolYearSelector;
